import Quill from "quill";

export class QuillCustomButtonHelper {
    static addInsertDiagramButton(quill: Quill, openDrawio: () => void) {
        const toolbar: any = quill.getModule('toolbar');
        if (!toolbar) return;

        // Register handler for custom button
        toolbar.addHandler('insertDiagram', openDrawio);

        // Access the toolbar DOM element
        const toolbarElem = toolbar.container as HTMLElement;

        // Avoid adding the button multiple times
        if (!toolbarElem.querySelector('.ql-insertDiagram')) {
            // Create the button element
            const button = document.createElement('button');
            button.classList.add('ql-insertDiagram', 'pi', 'pi-share-alt', 'fa-rotate-90', 'bg-orange-500');
            button.type = 'button';
            button.onclick = openDrawio;

            // Wrap it in a new format group (optional for consistent styling)
            const newGroup = document.createElement('span');
            newGroup.classList.add('ql-formats');
            newGroup.appendChild(button);

            // Append to the end of the toolbar
            toolbarElem.appendChild(newGroup);
        }
    }

    static addCustomButtons(
        quill: Quill,
        onCancel: () => void,
        onSave: () => void
    ) {
        const toolbar: any = quill.getModule('toolbar');
        if (!toolbar) return;

        const toolbarElem = toolbar.container as HTMLElement;

        // --- Prevent duplication ---
        if (toolbarElem.querySelector('.ql-mvs-cancel') ||
            toolbarElem.querySelector('.ql-mvs-save')) {
            return;
        }

        // --- Cancel Button ---
        const cancelBtn = document.createElement('button');
        cancelBtn.classList.add('ql-mvs-cancel', 'p-button', 'p-button-text', 'mx-3');
        cancelBtn.innerHTML = 'Cancel';
        cancelBtn.onclick = onCancel;

        // --- Save Button ---
        const saveBtn = document.createElement('button');
        saveBtn.classList.add('ql-mvs-save', 'p-button', 'bg-primary');
        saveBtn.innerHTML = 'Save';
        saveBtn.onclick = onSave;

        // Group for consistent Quill styling
        const group = document.createElement('span');
        group.classList.add('ql-formats', 'ql-mvs-action-buttons');
        group.appendChild(cancelBtn);
        group.appendChild(saveBtn);

        // Append at END of toolbar
        toolbarElem.appendChild(group);
    }
}
